import { useCallback } from 'react';
import DashboardCTA from '../../../dashboardComponents/DashboardCTA/DashboardCTA';
import { Button } from '@iwoca/orion';
import {
    FormattedMessage,
    WrappedComponentProps,
    injectIntl
} from 'react-intl';
import messages from './RepayEarlyForFree.messages';
import styles from '../DashboardActions.module.css';
import { connect } from 'react-redux';
import * as selectors from '../../../accountsSelector';
import { RootState } from '@iwProvider/configureStore';
import { Dispatch } from 'redux';
import { REQUEST_CHANGE_ROUTER } from '@iwRouter/IwRouter.actions';
import { PaymentCardSVG } from '@svgComponents/paymentCardSVG/PaymentCardSVG';
import { GoogleTagManager } from '@iwoca/frontend-tracking-library';
import { EARLY_REPAYMENT_ACCOUNT_ID } from '../../../../earlyRepayment/EarlyRepayment.actions';

const mapStateToProps = (state: RootState) => {
    const productType = selectors.getProductTypeFromURL();

    return {
        accountId: selectors.getAccountId(state, productType)
    };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
    addAccountIdToEarlyRepayment: (accountId: string) =>
        dispatch({
            type: EARLY_REPAYMENT_ACCOUNT_ID,
            accountId
        }),
    goToEarlyRepayment: () =>
        dispatch({
            type: REQUEST_CHANGE_ROUTER,
            location: { pathname: '/repayment/' }
        })
});

type PropsFromRedux = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

type Props = {
    className?: string;
} & PropsFromRedux &
    WrappedComponentProps;

const RepayEarlyForFree = ({
    accountId,
    addAccountIdToEarlyRepayment,
    goToEarlyRepayment,
    className
}: Props) => {
    const trackAndGoToEarlyRepayment = useCallback(() => {
        GoogleTagManager.trackClick({
            identifier: 'Make early repayment button'
        });

        addAccountIdToEarlyRepayment(accountId);
        goToEarlyRepayment();
    }, [accountId, addAccountIdToEarlyRepayment, goToEarlyRepayment]);

    return (
        <DashboardCTA
            title={<FormattedMessage {...messages.title} />}
            icon={<PaymentCardSVG />}
            className={className}
            description={<FormattedMessage {...messages.description} />}
            data-testid="repay-early-for-free"
            cta={
                <Button
                    variant="secondary"
                    data-testid="make-repayment-action-button"
                    onClick={trackAndGoToEarlyRepayment}
                    className={styles.dashboardActionCTA}
                >
                    <FormattedMessage {...messages.ctaText} />
                </Button>
            }
        />
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(injectIntl(RepayEarlyForFree));
